import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent {
  constructor() { }

  ngOnInit() {

    this.Load_slide();
  }

  data_slide = [];

  Load_slide() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbCPS].[dbo].[Slide_pic]&w=1=1';
    axios.get(url).then(res => {
      let data = res.data.sort().reverse();;
      if (data.length >= 1) {
        this.data_slide = data.filter(el => el.status == 1);
        console.log('data_slide: ', data);
      }
    }).catch(err => {
      throw (err)
    });
  }
}
